import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

export const ProductVolumePricingModalTableHeader: FC = () => {
  return (
    <tr>
      <th className="p-4 pb-2 text-left text-s font-medium text-dark-primary-max">
        <FormattedMessage id="volumePricing.modal.table.quantity.label" />
      </th>
      <th className="w-10 p-4 pb-2 pl-0 text-left text-s font-medium">
        <FormattedMessage id="volumePricing.modal.table.savingPrice.label" />
      </th>
      <th className="w-10 p-4 pb-2 pl-0 text-left text-s font-medium">
        <FormattedMessage id="volumePricing.modal.table.discount.label" />
      </th>
    </tr>
  )
}
